'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.POKLADNA = exports.BANKA = exports.FAKTURA = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ udávající za co vznikl souhrn vyrovnání.
 */

/**
 * Souhrn vznikl za případy modulu faktur.
 */
var FAKTURA = exports.FAKTURA = 'FAKTURA';

/**
 * Souhrn vznikl za položky poukazu modulu banka.
 */
var BANKA = exports.BANKA = 'BANKA';

/**
 * Souhrn vznikl za položky poukazu modulu pokladna.
 */
var POKLADNA = exports.POKLADNA = 'POKLADNA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [FAKTURA, BANKA, POKLADNA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, FAKTURA, { caption: 'Souhrn vznikl za případy modulu faktur.' }), (0, _defineProperty3.default)(_params, BANKA, { caption: 'Souhrn vznikl za položky poukazu modulu banka.' }), (0, _defineProperty3.default)(_params, POKLADNA, { caption: 'Souhrn vznikl za položky poukazu modulu pokladna.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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